<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Создание нацстатотчета') }}</h1>
    <div class="workroom-pg">
      <div class="bgw-pdg-20 passport-pg create">
        <div class="tab-main">
          <v-form
            class="form-ru"
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="createReportOopt"
          >
            <v-row :class="{ invalid: $v.reportOopt.oopt.$error }" v-if="oopts.length > 1">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Организации') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Организации')"/>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-select
                    :items="oopts"
                    item-value="id"
                    item-text="transName"
                    v-model="reportOopt.oopt"
                    outlined
                    dense
                    required
                    clearable
                    @change="reportList"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.reportOopt.report.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>
                  {{ $t('Отчет') }}: <span class="asterix">*</span>
                  <fieldInfo :info="$t('Отчет')"/>
                </v-label>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-select
                    :items="reports"
                    item-value="id"
                    item-text="transName"
                    v-model="reportOopt.report"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.reportOopt.year.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>
                  {{ $t('Год') }}: <span class="asterix">*</span>
                  <fieldInfo :info="$t('Год')"/>
                </v-label>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-select
                    :items="years"
                    item-value="id"
                    item-text="transName"
                    v-model="reportOopt.year"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <div class="form-action border-none">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                type="button"
                class="btn btn-default gray"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import Report from '@/model/report'
import fieldInfo from '@/components/app/fieldInfo'
import { required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'

export default {
  components: {
    fieldInfo
  },
  data: () => ({
    valid: true,
    oopts: [],
    years: [],
    reports: [],
    reportOopt: {
      oopt: '',
      year: '',
      report: ''
    },
    rules: {
      reportOopt: {
        oopt: { required },
        year: { required },
        report: { required }
      }
    },
    breadcrumbs: []
  }),
  mounted () {
    this.setLoading(true)
    Report.getFormData()
      .then((response) => {
        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
          { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
          { text: this.$i18n.t('Нацстатотчеты'), disabled: false, href: '/reports/all' },
          { text: this.$i18n.t('Создание нацстатотчета'), disabled: true }
        ]
        this.oopts = response.data.oopts
        this.years = response.data.years
        this.reportOopt.oopt = this.oopts[0]
        const ooptId = this.reportOopt.oopt.id
        this.reportList(ooptId)
        this.setLoading(false)
      })
      .catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
        this.setLoading(false)
      })
  },
  created () {
    this.scrollToTop()
  },
  validations () {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    reportList (ooptId) {
      Report.listReportByOopt(ooptId)
        .then((response) => {
          this.reports = response.data.reports
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание отчета
    createReportOopt () {
      if (!this.validateForm()) {
        return
      }
      this.setLoading(true)
      if (this.reportOopt.oopt instanceof Object) {
        this.reportOopt.oopt = this.reportOopt.oopt.id
      }
      Report.create(this.reportOopt)
        .then((response) => {
          if (response.status === 201) {
            this.$noty.success(this.$i18n.t('Успешно добавлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
            this.$router.push({
              name: 'reports',
              params: { id: 'all' }
            })
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'reports',
        params: { id: 'all' }
      })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
